module.exports = __webpack_public_path__ + "img/logo.9657f320.png";